import { pascalCase } from 'scule'
/*import { localComponents, localComponentLoaders } from '#content/components'*/

// Define component imports for the docs app
const components: Record<string, () => Promise<unknown>> = {
    // Nuxt UI page components used in playground examples (explicit imports to ensure bundle inclusion)
    Alert: () => import('@nuxt/ui/components/Alert.vue'),
    PageHero: () => import('@nuxt/ui/components/PageHero.vue'),
    PageSection: () => import('@nuxt/ui/components/PageSection.vue'),
    PageHeader: () => import('@nuxt/ui/components/PageHeader.vue'),
    PageBody: () => import('@nuxt/ui/components/PageBody.vue'),
    PageCard: () => import('@nuxt/ui/components/PageCard.vue'),
    PageColumns: () => import('@nuxt/ui/components/PageColumns.vue'),
    PageCTA: () => import('@nuxt/ui/components/PageCTA.vue'),
    PageFeature: () => import('@nuxt/ui/components/PageFeature.vue'),
    PageGrid: () => import('@nuxt/ui/components/PageGrid.vue'),
}

export default function comarkResolveComponent(name: string) {
    if (name === 'span') {
        return null
    }

    const pascalName = pascalCase(name)

    // 1. Explicit local components
    const loader = components[name] || components[pascalName]
    if (loader) return loader()

    return null
}